import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { SingleValue } from 'react-select';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../../i18n/constants/keys';
import {
  QuestionSearch,
  SubSkill,
} from '../../../../../../../../utils/types/assessment_types';
import { SelectOptions } from '../../../../../../../../utils/types/react_select_types';

type FilterProps = {
  skillList: SelectOptions[];
  levelList: SelectOptions[];
  subSkillList: SubSkill[] | undefined;
  jobTitleList: SelectOptions[] | undefined;
  searchObject: QuestionSearch;
  setSearchObject: (searchObject: QuestionSearch) => void;
};

const customStyles = {
  container: (base: any) => ({
    ...base,
    width: '200px',
  }),
};

export const Filter = ({
  skillList,
  levelList,
  subSkillList,
  jobTitleList,
  searchObject,
  setSearchObject,
}: FilterProps) => {
  const { t } = useTranslation(NS.adminPages);
  const QF = ADMIN_PAGES_KEYS.jobOpenings.questionFilter;
  const [subSkills1, setSubSkills1] = useState<SelectOptions[]>();
  const [subSkills2, setSubSkills2] = useState<SelectOptions[]>();
  const [subSkills3, setSubSkills3] = useState<SelectOptions[]>();

  const returnSubSkills = (parent: string | undefined) => {
    let subSkills: SelectOptions[] = [];
    subSkillList?.map((subSkill: SubSkill) => {
      if (subSkill.parentSkillId === parent) {
        subSkills.push({ label: subSkill.subskillName, value: subSkill.id });
      }
    });

    return subSkills;
  };

  const handleSelectChange = (
    selectedValue: SingleValue<SelectOptions>,
    action: any,
  ) => {
    if (action.name === 'skillId') {
      selectedValue &&
        setSubSkills1(() => returnSubSkills(selectedValue.value));
      setSubSkills2([]);
      setSubSkills3([]);
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill1Id: '',
        subSkill2Id: '',
        subSkill3Id: '',
      });
    } else if (action.name === 'subSkill1Id') {
      selectedValue &&
        setSubSkills2(() => returnSubSkills(selectedValue.value));
      setSubSkills3([]);
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill2Id: '',
        subSkill3Id: '',
      });
    } else if (action.name === 'subSkill2Id') {
      selectedValue &&
        setSubSkills3(() => returnSubSkills(selectedValue.value));
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill3Id: '',
      });
    } else {
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
      });
    }
  };

  const onSearchTermChange = (event: ChangeEvent<HTMLInputElement>) => {
    let searchTitle = event.target.value;
    setSearchObject({
      ...searchObject,
      questionTitle: searchTitle,
    });
  };

  return (
    <div className='flex flex-col gap-5 max-w-[200px]'>
      <h2 className='font-medium'>{ t(QF.applyFilters) }</h2>
      <Select
          placeholder={t(QF.selectSkill)}
          name='skillId'
          options={skillList}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
      />
      { searchObject.skillId !== null && searchObject.skillId.length > 0 && (
        <Select
            placeholder={t(QF.selectSubSkill1)}
            name='subSkill1Id'
            options={subSkills1}
            onChange={handleSelectChange}
            isClearable={true}
            styles={customStyles}
        />
      ) }
      { searchObject.subSkill1Id.length > 0 && (
        <Select
            placeholder={t(QF.selectSubSkill2)}
            name='subSkill2Id'
            options={subSkills2}
            onChange={handleSelectChange}
            isClearable={true}
            styles={customStyles}
        />
      ) }
      { searchObject.subSkill2Id.length > 0 && (
        <Select
            placeholder={t(QF.selectSubSkill3)}
            name='subSkill3Id'
            options={subSkills3}
            onChange={handleSelectChange}
            isClearable={true}
            styles={customStyles}
        />
      ) }
      <Select
          placeholder={t(QF.selectSkillLevel)}
          name='levelId'
          options={levelList}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
      />
      <Select
          placeholder={t(QF.selectJobTitle)}
          name='jobTitle'
          options={jobTitleList}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
      />
      <input
          className='placeholder-secondary-grey-200 block px-2 py-2 border shadow-sm rounded-md normal-case font-normal text-base leading-6 focus:outline-none focus:border-primary-blue-500'
          type='text'
          placeholder={t(QF.searchQuestions)}
          onChange={onSearchTermChange}
      />
    </div>
  );
};
